import React, { useEffect, useState } from 'react'
import { FaCalendar, FaDownload } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import { downloadReportByDateRange } from '../../utils/reportUtils';
import './DownloadReport.css';

const DownloadReport = ({ isOpen, onClose, reportTitle }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    const handleDownload = () => {
        setError('');

        if (!startDate || !endDate) {
            setError('Both start and end dates are required');
            return;
        }

        if (new Date(startDate) > new Date(endDate)) {
            setError('Start date must be before end date');
            return;
        }

        // onDownload({ startDate, endDate });
        downloadReportByDateRange(reportTitle, startDate, endDate);
        setStartDate('');
        setEndDate('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="download-modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Download {reportTitle === "applications" ? "Applications" : reportTitle === "leads" ? "Leads" : reportTitle === "limit-sanction" ? "Limit Sanction" : reportTitle === "demand" ? "Demand" : reportTitle === "supplier" ? "Supplier" : reportTitle === "tranche" ? "Tranche" : reportTitle === "repayment" ? "Repayment" : reportTitle === "active-customer" ? "Active Customer" : "payment-transaction" ? "Payment Transactions" : ""} Report</h5>
                        <button onClick={onClose} className="btn-close">
                            {/* <IoMdClose size={20} /> */}
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">
                                <FaCalendar size={16} className="me-2" />
                                Start Date
                            </label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className="form-control"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                <FaCalendar size={16} className="me-2" />
                                End Date
                            </label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                className="form-control"
                            />
                        </div>

                        {error && (
                            <div className="alert alert-danger">
                                {error}
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button onClick={onClose} className="btn btn-secondary">
                            Cancel
                        </button>
                        <button onClick={handleDownload} className="search-btn">
                            {/* <FaDownload size={18} className="me-2" /> */}
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DownloadReport